<template>
  <div style="padding-top: 100px">
    <div class="container btn-flat">
      <footer class="caixa-flutuante-inferior flow-text" style="background-color: white !important; color: black;">
        <div class="col" @click="Produtos()">
          <span class="row center" id="menuProdutos">
            <i class="left material-icons">menu</i>
            {{ $t('produtos') }}
          </span>
        </div>

        <!-- Opções para cliente logado -->
        <div v-if="clienteLogado" class="col" style="display: flex; align-items: center;">
          <span v-if="podeAcompanharPedidos" class="row center" @click="UltimosPedidos()" id="menuPerfil">
            <i class="left material-icons">person</i> {{ $t('meus_pedidos') }}
          </span>
          <span class="row center" @click="Deslogar()" style="margin-left: 20px;">
            <i class="left material-icons">exit_to_app</i> {{ $t('sair') }}
          </span>
        </div>

        <!-- Opção para cliente não logado -->
        <div v-else class="col" @click="NovoCadastro()">
          <span class="row center">
            <i class="left material-icons">exit_to_app</i> {{ $t('pedidos_label') }}
          </span>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { ChecarLogin, Logout } from "../../services/auth";

export default {
  name: "MeuLoginBlocoFlutuanteComponent",
  data() {
    return {
      clienteLogado: this.$store.state.is_cliente_logado,
    };
  },
  computed: {
    podeAcompanharPedidos() {
      const empresa = this.$store && this.$store.state ? this.$store.state.empresa : null;
      const flag = empresa ? empresa.desativar_acompanhar_ultimo_pedido : null;
      return String(flag || "N").trim().toUpperCase() !== "S";
    }
  },
  async mounted() {
    this.DestacarAba();
    let clienteLogado = await ChecarLogin(this.$store.state.apiUrl);
    this.$store.commit("isClienteLogado", clienteLogado);
    this.clienteLogado = clienteLogado;
  },
  methods: {
    Produtos() {
      if (this.$route.name != "Cardapio")
        this.$router.push("/" + this.$store.state.empresa_url + "/menu");
    },
    PerfilCliente() {
      if (this.$route.name != "PerfilCliente")
        this.$router.push("/" + this.$store.state.empresa_url + "/cliente-perfil");
    },
    UltimosPedidos() {
      if (!this.podeAcompanharPedidos) return;
      this.$router.push("/" + this.$store.state.empresa_url + "/cliente-pedidos");
    },    
    NovoCadastro() {
      this.$router.push("/" + this.$store.state.empresa_url + "/login");
    },
    async Deslogar() {
      await Logout();
      this.$router.push("/" + this.$store.state.empresa_url);
    },
    DestacarAba() {
      if (this.$route.name == "Cardapio") {
        $("#menuProdutos").addClass("cor-primaria-text");
      } else {
        $("#menuProdutos").removeClass("cor-primaria-text");
      }

      if (this.$route.name == "PerfilCliente") {
        $("#menuPerfil").addClass("cor-primaria-text");
      } else {
        $("#menuPerfil").removeClass("cor-primaria-text");
      }
    },
  },
};
</script>

<style scoped>
.caixa-flutuante-inferior.closed {
  flex-direction: column;
  height: 120px;
  -webkit-box-align: center;
  align-items: center;
}
.caixa-flutuante-inferior {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 50px;
  width: 100%;
  box-shadow: rgba(48, 51, 60, 0.25) 0px -1px 2px;
  max-width: 800px;
  padding: 0.5rem 2rem;
  margin: 0px auto;
  color: #fff;
}

.col {
  display: flex;
  align-items: center;
}
.row.center {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.row.center:hover {
  color: #2196f3; /* Cor ao passar o mouse */
}
.material-icons {
  margin-right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/Widgets/MeuLoginBlocoFlutuanteComponent.vue